
import {
  DateFormatHelper,
  DateOptionsBuilder,
  DayFormats,
  MonthFormats,
  WeekdayFormats,
} from '@/ui-kit/helpers/DateFormatHelper';
import ListingBookViewingCard from './card';

const WEEKDAY_FORMAT = new DateOptionsBuilder()
  .addWeekdayFormat(WeekdayFormats.Long)
  .build();
const DAY_FORMAT = new DateOptionsBuilder()
  .addDayFormat(DayFormats.Numeric)
  .build();
const MONTH_FORMAT = new DateOptionsBuilder()
  .addMonthFormat(MonthFormats.Short)
  .build();

export default {
  name: 'ListingBookViewingDateCard',
  components: {
    ListingBookViewingCard,
  },
  props: {
    dateString: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    weekday() {
      return DateFormatHelper.format(this.dateString, WEEKDAY_FORMAT);
    },
    day() {
      return DateFormatHelper.format(this.dateString, DAY_FORMAT);
    },
    month() {
      return DateFormatHelper.format(this.dateString, MONTH_FORMAT);
    },
  },
};
